import { createSlice } from "@reduxjs/toolkit";

const postsSlice = createSlice({
  name: "posts",
  initialState: [],
  reducers: {
    setPosts: (state, action) => {
      return action.payload;
    },
  },
});

// Export actions
export const { setPosts } = postsSlice.actions;

// Export reducer
export default postsSlice.reducer;
